// extracted by mini-css-extract-plugin
export default {"screen-loading":"PaymentsSetup_screen-loading__XI2ne"};